<template>
    <section class="c-dashboard">
        <app-intro>
            <h1>Prijs aanvragen</h1>
            <p>Ingevulde e-mailadressen</p>
        </app-intro>

        <transition-group class="c-grid-list" name="fade" tag="section">
            <div key="table" class="table table--bordered" v-if="emails.length > 0">
                <div class="table__thead">
                    <div class="table__tr" v-for="email in emails" :key="'thead-' + email.id">
                        <div class="table__th">Email</div>
                        <div class="table__th">Aanvragen</div>
                        <div class="table__th">Account</div>
                        <div class="table__th">Datum</div>
                    </div>
                </div>
                <div class="table__tbody">
                    <div class="table__tr" v-for="email in emails" :key="'tbody-' + email.id">
                        <div class="table__td">{{ email.email }}</div>
                        <div class="table__td">{{ email.requests }}</div>
                        <div class="table__td">{{ email.account.firstname ? 'Ja' : 'Nee' }}</div>
                        <div class="table__td">{{ email.last_request.friendly }}</div>
                    </div>
                </div>
            </div>
        </transition-group>

        <loading v-bind:nodes="emails">Bezig met laden van de prijs aanvragen...</loading>
    </section>
</template>

<script>
    import { mapState } from 'vuex';
    import AppIntro from '../components/app/AppIntro.vue';
    import Loading from '../components/Loading.vue';

    export default {
        components: { AppIntro, Loading },
        computed: {
            ...mapState({
                emails: (state) => state.priceRequest.all,
            }),
        },
        created () {
            this.$store.dispatch('priceRequest/getAll');
        },
    };
</script>

<style lang="scss" scoped>
    @import "../assets/scss/essentials";

    .table {
        @include media-breakpoint-only(sm) {
            grid-template-columns: rem(150) 1fr;
        }

        &__tr {
            @include media-breakpoint-up(md) {
                grid-template-columns: repeat(4, 1fr);
            }

            @include media-breakpoint-up(lg) {
                grid-template-columns: repeat(3, 1fr) rem(200);
            }
        }
    }
</style>
